import styled from 'styled-components/macro'
import { ifProp, prop } from 'styled-tools'
import { media } from 'ui/rwd'
import { Container } from 'reactstrap'

const Grid = styled.div`
 transition: 0.4s ease-in-out;
  background-image: url('${prop('backgroundImage', '')}');
  background-size: cover;
  background-position: center center;
  height: 160px;
  overflow: hidden;
  display:flex;
  border-radius: 1rem;
  ${media.sm`
    height: 220px;
  `}
  ${media.lg`
    height: 260px;
  `}
`

const ContentItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const BanerContainer = styled(Container)`
  padding: 0 !important;
  ${media.sm`
      ${ifProp(
    { fluid: true },
    'padding: 0 !important',
    'padding: 0px 15px !important'
  )};
  `}
`

export { BanerContainer, ContentItem, Grid }
